module.exports = __webpack_public_path__ + "static/media/bg-BG.dc69da3b.md";